module.exports = __webpack_public_path__ + "static/thumb-zitno-polje-fad0e2146cf698845ab7a9aa5445dc7b.jpg";